module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-3-sel.c1ceb5fa.svg";